import React from 'react';
import LogoHorizontalIcon from '@moda/icons/logo-horizontal-189-x-12';
import { colors } from '@moda/tokens';
import { Constrain } from '@moda/om';
import { useEnableClubModa } from '../../../hooks/useEnableClubModa';
import { Link } from '../../Link';
import { DesktopNavigation } from '../../DesktopNavigation';
import { DesktopNavigationMainContent } from '../../DesktopNavigation/DesktopNavigationMainContent';
import { DesktopSiteNavActions } from './DesktopSiteNavActions';

import './DesktopSiteNav.scss';

export const DesktopSiteNav: React.FC = () => {
  const enableClubModa = useEnableClubModa();

  return (
    <nav className="DesktopSiteNav">
      <Constrain className="DesktopSiteNav__primary">
        <DesktopNavigation />
        <div className="DesktopSiteNav__logo" data-testid="logo">
          <Link aria-label="Moda Operandi Home Page" to="/">
            <LogoHorizontalIcon
              width="100%"
              height="100%"
              className="DesktopSiteNav__logo-icon"
              color={enableClubModa ? colors.all['waikawa-gray'] : undefined}
            />
          </Link>
        </div>
        <DesktopSiteNavActions />
      </Constrain>

      <Constrain>
        <DesktopNavigationMainContent />
      </Constrain>
    </nav>
  );
};
